// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__V1aIm","placeholdersHeader":"styles_placeholdersHeader__3Ra5j","editorStyle":"styles_editorStyle__3xhUH","placeholdersBox":"styles_placeholdersBox__3hbf0"};